import React, { Component } from 'react'
import { connect } from 'react-redux';
import { compose } from 'redux';
import { firestoreConnect } from 'react-redux-firebase';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import * as ROUTES from '../../../constants/routes';
import PricingModal from './PricingModal';
import ReactModal from 'react-modal';
import { openNewAuthChangesModal } from '../../../store/actions/authActions';
import AuthWrapper from '../../auth/forms/AuthWrapper';
const ViewButton = styled.div`
    .btn {
        color: #fafafa;
        border-color: ${(props) => props.themeColors.themeColor};
        background-color: ${(props) => props.themeColors.themeColor};
        margin: 2px;

        &:hover {
            color: #fafafa;
            background-color: ${(props) => props.themeColors.themeColor};
        }

        &:active {
            color: #fafafa;
            background-color: ${(props) => props.themeColors.themeColor};
        }
    }
`;
class IndividualProduct extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showPaymentModal: false,
            toggle: false,
        };
    }

    componentDidMount() {

    }

    // README: MODAL CONTROLLING
    handleOpenModal = () => {
        this.setState({ showPaymentModal: true });
    }

    handleCloseModal = () => {
        this.setState({ showPaymentModal: false });
    }
    render() {
        const { individualProduct, isSignedIn, themeColors, modalStyles, payment, commons, storeInfo } = this.props;
        if (!individualProduct || !storeInfo) {
            return (<React.Fragment />)
        }
        const { buyProdActMessage } = payment
        const isMessageReceived = buyProdActMessage !== ''
        const schemeList = ['month', 'year', 'lifetime', 'day'];
        const schemeName = schemeList[individualProduct ? individualProduct.scheme : ''];

        const discountPrice = individualProduct.featured === true ? Math.round((((100 - storeInfo.discountPercentage) / 100) * individualProduct.price)) : individualProduct.price;
        const priceSaveMessage = individualProduct.featured === true ? `${storeInfo.priceSaveMessage} ${commons.priceIn}${individualProduct.price - discountPrice}` : ""

        const relevantButton = isSignedIn ? <button className="btn btn-flat my-3" onClick={() => this.handleOpenModal()}>Subscribe now{isMessageReceived ? ' again?' : ''}</button> :
            // <Link to={ROUTES.SIGN_UP} className="btn btn-flat my-3">Sign up for free</Link>
            <button className="btn btn-flat my-3" onClick={() => { this.setState({ toggle: true }); this.props.openNewAuthChangesModal() }} >Sign up for free</button>

        const fontStyle = {
            fontSize: '13px',
        }
        return (
            <div className="container-fluid container-form">
                <div className="card h-100" style={{ borderRadius: '10px' }}>

                    <div className="card-header" style={{}}>
                        {/* <h6><b>{individualProduct ? individualProduct.itemName : ''}</b></h6> */}
                        <h6 className="align-self-center"><b>{individualProduct ? individualProduct.itemName : ''}</b></h6>
                        <div className="align-self-center"><span style={{ fontSize: '50px', fontWeight: 'bold' }}> {commons.priceIn}{discountPrice}</span><span style={{ color: "gray", fontSize: '14px' }}> /{schemeName}</span><span style={{ fontSize: '30px', color: 'grey', marginLeft: '5px' }}>{individualProduct ? individualProduct.featured === true ? '*' : <React.Fragment /> : <React.Fragment />}</span></div>
                        <div className="align-self-center"><span style={{ color: "gray", fontSize: '14px' }}> {priceSaveMessage}</span></div>
                    </div>

                    <div className="card-body" style={{ paddingLeft: '0px', paddingRight: '0px' }}>
                        <div style={{ backgroundColor: 'transparent', paddingInline: '10%' }}>
                            <ul className="list-group list-group-flush text-center" style={{}}>
                                <li className="list-group-item text-left" style={fontStyle}><span className="">{commons.udefectMarkers} Limit:&nbsp;</span>{individualProduct ? individualProduct.tagLimit === '-1' ? `${commons.uunlimited}` : individualProduct ? individualProduct.tagLimit : '' : ''}</li>
                                <li className="list-group-item text-left" style={fontStyle}><span className="">Company Members:&nbsp;</span>{individualProduct ? individualProduct.companyMembersLimit === '-1' ? `${commons.uunlimited}` : individualProduct ? individualProduct.companyMembersLimit : '' : ''}</li>
                                <li className="list-group-item text-left" style={fontStyle}><span className="">Internal {commons.project} members:&nbsp;</span>{individualProduct ? individualProduct.internalProjectMembersLimit === '-1' ? `${commons.uunlimited}` : individualProduct ? individualProduct.internalProjectMembersLimit : '' : ''}</li>
                                <li className="list-group-item text-left" style={fontStyle}><span className="">External {commons.project} members:&nbsp;</span>{individualProduct ? individualProduct.externalProjectMembersLimit === '-1' ? `${commons.uunlimited}` : individualProduct ? individualProduct.externalProjectMembersLimit : '' : ''}</li>

                            </ul>
                        </div>
                    </div>
                    <div className="card-footer mt-auto" style={{ backgroundColor: "white", borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px' }}>
                        <ViewButton themeColors={themeColors}>
                            {relevantButton}
                        </ViewButton>
                        <p>{buyProdActMessage}</p>
                    </div>
                    <ReactModal
                        style={modalStyles}
                        isOpen={this.state.toggle && !isSignedIn}
                        onRequestClose={() => { this.setState({ toggle: false }) }}
                        contentLabel="See controls"
                        ariaHideApp={false}
                    >
                        <button className="close" onClick={() => { this.setState({ toggle: false }) }}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <AuthWrapper />
                    </ReactModal>
                    <ReactModal
                        style={modalStyles}
                        isOpen={this.state.showPaymentModal}
                        onRequestClose={() => { this.handleCloseModal() }}
                        contentLabel="See all payment methods"
                        ariaHideApp={false}
                    >
                        <button className="close" onClick={() => { this.handleCloseModal() }}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <PricingModal priceCard={individualProduct} storeInfo={storeInfo} />
                    </ReactModal>
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        individualProduct: state.firestore.data.IndividualProduct,
        isSignedIn: !state.firebase.auth.isEmpty,
        modalStyles: state.appControl.modalStyles,
        payment: state.payment,
        commons: state.commons,
        storeInfo: state.firestore.data.StoreInfo,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        openNewAuthChangesModal: () => dispatch(openNewAuthChangesModal()),
    }
}
export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    firestoreConnect((props) => {
        // console.log(props)
        let productId = props.match.params.product_id;
        console.log(productId);
        return [
            {
                collection: "Store",
                doc: productId,
                storeAs: "IndividualProduct",
            },
            {
                collection: "Configurations",
                doc: "StoreInfo",
                storeAs: "StoreInfo",
            }
        ]
    })
)(IndividualProduct);

